/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AgreementViewRequiredAgreementTermsFragmentDoc } from './AgreementView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type TermType =
  /** プライバシーポリシー */
  | 'PRIVACY_POLICY'
  /** 通信の秘密 */
  | 'SECRECY_OF_COMMUNICATIONS'
  /** 利用規約 */
  | 'TERMS_OF_SERVICE';

export type AgreementModalViewerFragment = { id: string, requiredAgreementTerms: Array<{ id: string, type: Types.TermType, title: string, body: MarkdownString }> };

export type AgreeTermsRequireAgreementMutationVariables = Exact<{
  termRevisionIDs: Array<string | number> | string | number;
}>;


export type AgreeTermsRequireAgreementMutation = { agreeTerms: { requiredAgreementTerms: Array<{ id: string, type: Types.TermType, title: string, body: MarkdownString }> } };

export const AgreementModalViewerFragmentDoc = gql`
    fragment AgreementModalViewer on Viewer {
  id
  ...AgreementViewRequiredAgreementTerms
}
    ${AgreementViewRequiredAgreementTermsFragmentDoc}`;
export const AgreeTermsRequireAgreementDocument = gql`
    mutation agreeTermsRequireAgreement($termRevisionIDs: [ID!]!) {
  agreeTerms(termRevisionIDs: $termRevisionIDs) {
    requiredAgreementTerms {
      id
      type
      title
      body
    }
  }
}
    `;

/**
 * __useAgreeTermsRequireAgreementMutation__
 *
 * To run a mutation, you first call `useAgreeTermsRequireAgreementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAgreeTermsRequireAgreementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAgreeTermsRequireAgreementMutation({
 *   variables: {
 *     termRevisionIDs: // value for 'termRevisionIDs'
 *   },
 * });
 */
export function useAgreeTermsRequireAgreementMutation(options: VueApolloComposable.UseMutationOptions<AgreeTermsRequireAgreementMutation, AgreeTermsRequireAgreementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AgreeTermsRequireAgreementMutation, AgreeTermsRequireAgreementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AgreeTermsRequireAgreementMutation, AgreeTermsRequireAgreementMutationVariables>(AgreeTermsRequireAgreementDocument, options);
}
export type AgreeTermsRequireAgreementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AgreeTermsRequireAgreementMutation, AgreeTermsRequireAgreementMutationVariables>;